function convertTimeZone(timezone) {
    let date = new Date();
    const timeZone = date.toLocaleString("en-US", {timeZone: timezone});
    return timeZone;
}
export default convertTimeZone;